import { Layout } from "@/components/layout/Layout";

export function Privacy() {
  return (
    <Layout>
      <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 prose prose-neutral dark:prose-invert">
        <p className="text-xs uppercase tracking-widest text-muted-foreground not-prose">Editable placeholder</p>
        <h1 className="font-display text-4xl sm:text-5xl mt-1 not-prose">Privacy</h1>
        <p className="mt-6 text-foreground/85">
          Play Tsoro works without an account. Your settings, saved game, and statistics are stored locally in your
          browser (using <code>localStorage</code>) and never transmitted to our servers by default.
        </p>
        <p className="text-foreground/85">
          A small anonymous usage analytics script (PostHog) is loaded by the hosting platform to help debug the app.
          No game-board data is sent and no marketing trackers are used.
        </p>
        <p className="text-foreground/85">
          This placeholder will be replaced with a properly reviewed privacy notice before any production launch. The
          presence of this page is not a claim of legal compliance.
        </p>
      </article>
    </Layout>
  );
}
